/**
 * 停车场后台页面公共工具。创建于 2026-10-10
 */
import { getButtonList } from '@/utils/routeButtonList'

/**
 * 读取当前页面在菜单中配置的按钮 Func 列表（角色未分配的按钮不会返回）。最后修改：2026-10-10
 * @param {string} routePath - 当前路由 path
 * @returns {string[]}
 */
export function loadButtonFuncs(routePath) {
  let routers = []
  try {
    routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : []
  } catch (e) {
    routers = []
  }
  return getButtonList(routePath, routers).map(item => item.Func).filter(Boolean)
}

/**
 * 按菜单按钮权限过滤工具栏：查询按钮始终保留，其余按钮只有分配了对应 Func 才显示。最后修改：2026-10-10
 * @param {Array} definitions - 页面内的按钮定义（name/Func/icon/btnType），决定顺序与样式
 * @param {string[]} funcs - loadButtonFuncs 返回的已授权 Func
 * @returns {Array}
 */
export function buildToolbarButtons(definitions, funcs) {
  return definitions
    .filter(item => item.always || funcs.includes(item.Func))
    .map(item => ({ IsHide: false, ...item }))
}

/**
 * 将接口返回对象的键统一转为驼峰（兼容 PascalCase / camelCase 两种序列化）
 * @param {*} value - 接口返回的任意值
 * @returns {*}
 */
export function toCamel(value) {
  if (Array.isArray(value)) return value.map(toCamel)
  if (!value || typeof value !== 'object') return value
  return Object.keys(value).reduce((acc, key) => {
    const camelKey = key.charAt(0).toLowerCase() + key.slice(1)
    acc[camelKey] = toCamel(value[key])
    return acc
  }, {})
}

/**
 * 读取分页响应（PageModel），返回 { list, total }
 * @param {Object} res - axios 响应
 */
export function readPage(res) {
  const page = toCamel((res && res.data && res.data.response) || {})
  return { list: page.data || [], total: page.dataCount || 0, raw: page }
}

/**
 * 格式化时间为 yyyy-MM-dd HH:mm
 * @param {string|Date} val
 */
export function formatDateTime(val) {
  if (!val) return ''
  const d = new Date(val)
  if (isNaN(d.getTime())) return val
  const pad = n => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`
}

/** 长期车牌申请状态显示 */
export const plateStatusMap = {
  Pending: { label: '待审批', type: 'warning' },
  Approved: { label: '已通过', type: 'success' },
  Rejected: { label: '已驳回', type: 'danger' },
  Cancelled: { label: '已撤销', type: 'info' }
}

/** 临时车申请状态显示 */
export const tempStatusMap = {
  Pending: { label: '待审批', type: 'warning' },
  Approved: { label: '已生效', type: 'success' },
  Rejected: { label: '已驳回', type: 'danger' },
  Cancelled: { label: '已取消', type: 'info' },
  Expired: { label: '已过期', type: 'info' }
}
